import { FC } from "preact/compat";
import { me, useApp } from "~/core/store";
import MenuLink from "./MenuLink";
import navigation from "./navigation";
import cn from "classnames";

const Menu: FC = () => {
    const {
        status,
        api: { connection },
    } = useApp();
    const userPicture = connection?.value?.user.picture;

    return (
        <div
            className={cn(
                "hidden md:flex",
                "relative z-40 w-[50px] min-w-[50px] flex-col justify-between bg-header-mobile",
                status.lost.value && "grayscale",
            )}
        >
            <nav>
                <ul className="flex flex-col items-center">
                    {navigation.top().map((props) => (
                        <li key={props.path} className="group relative w-full">
                            <MenuLink {...props} />
                        </li>
                    ))}
                </ul>
            </nav>
            <ul className="flex flex-col items-center">
                {navigation.bottom().map((props) => (
                    <li key={props.path} className="group relative w-full">
                        <MenuLink
                            img={
                                props.path === me("profile")
                                    ? userPicture
                                    : undefined
                            }
                            {...props}
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Menu;
